import React from 'react';
import { Users, FolderGit2, Briefcase, CalendarClock, Award, HandHeart, Star } from 'lucide-react';
import useResponsive from '../hooks/useResponsive';

const FEATURES = [
  { icon: Users,        color:'#60a5fa', title:'Expert Trainers',   desc:'10+ saal ka real industry experience rakhne wale professionals se sikhiye.' },
  { icon: FolderGit2,   color:'#f97316', title:'Live Projects',      desc:'Real client projects pe kaam karo. Resume ke liye solid portfolio banao.' },
  { icon: Briefcase,    color:'#4ade80', title:'100% Placement',     desc:'Dedicated placement cell, 200+ companies, mock interviews sab included.' },
  { icon: CalendarClock,color:'#c084fc', title:'Flexible Batches',   desc:'Morning, Evening, Weekend — working professionals ke liye bhi perfect.' },
  { icon: Award,        color:'#fbbf24', title:'Certifications',     desc:'Globally recognized certificates milte hain course completion pe.' },
  { icon: HandHeart,    color:'#f43f5e', title:'Lifetime Support',   desc:'Course ke baad bhi mentor support. Alumni network hamesha ke liye.' },
];

const COMPANIES = [
  { logo:'G',   name:'Google' },
  { logo:'TCS', name:'TCS' },
  { logo:'INF', name:'Infosys' },
  { logo:'MS',  name:'Microsoft' },
  { logo:'Z',   name:'Zomato' },
  { logo:'P',   name:'Paytm' },
];

export default function About() {
  const { isMobile, isTablet } = useResponsive();
  const paddingH = isMobile ? 16 : isTablet ? 24 : 40;

  return (
    <div style={{ padding: `80px ${paddingH}px`, minHeight:'100vh', paddingTop:'80px' }}>
      <div style={{
        display:'grid',
        gridTemplateColumns: isMobile ? '1fr' : isTablet ? '1fr' : '1fr 1fr',
        gap: isMobile ? 40 : isTablet ? 40 : 60,
        alignItems:'center', maxWidth:1200, margin:'0 auto'
      }}>

        {/* ── Left ── */}
        <div>
          <div style={{ display:'inline-flex', alignItems:'center', gap:7, padding:'6px 16px', borderRadius:99, background:'rgba(255,255,255,0.04)', border:'1px solid rgba(255,255,255,0.07)', fontSize:12, fontWeight:600, color:'#60a5fa', marginBottom:18 }}>
            <Star size={13} strokeWidth={2.5} color="#60a5fa" />
            Why Trinity Global?
          </div>

          <h2 style={{ fontFamily:"'Outfit',sans-serif", fontSize: isMobile?30:isTablet?36:42, fontWeight:800, color:'#fff', letterSpacing:-1, marginBottom:18, lineHeight:1.15 }}>
            Sirf Padhna Nahi,<br />
            <span style={{ background:'linear-gradient(135deg,#38bdf8,#f97316,#c084fc)', backgroundSize:'300%', WebkitBackgroundClip:'text', WebkitTextFillColor:'transparent', backgroundClip:'text', animation:'gx 5s ease infinite' }}>Career Banana</span><br />
            Hai Humara Kaam
          </h2>

          <p style={{ fontFamily:"'DM Sans',sans-serif", fontSize:15, color:'#64748b', lineHeight:1.9, marginBottom:28 }}>
            Trinity Global mein hum sirf theory nahi, practical skills sikhate hain. Hamare students top MNCs aur startups mein kaam kar rahe hain — real experience ke saath, real confidence ke saath.
          </p>

          <div style={{ display:'flex', flexDirection:'column', gap:10 }}>
            {COMPANIES.map(c => (
              <div key={c.name} style={{ display:'flex', alignItems:'center', gap:12 }}>
                <div style={{ width:34, height:34, borderRadius:8, display:'flex', alignItems:'center', justifyContent:'center', fontFamily:"'Outfit',sans-serif", fontWeight:800, fontSize:11, color:'#60a5fa', background:'rgba(37,99,235,0.1)', border:'1px solid rgba(37,99,235,0.15)', flexShrink:0 }}>{c.logo}</div>
                <span style={{ fontFamily:"'DM Sans',sans-serif", fontSize:13, color:'#94a3b8', fontWeight:500 }}>{c.name}</span>
                <div style={{ flex:1, height:1, background:'linear-gradient(to right,rgba(37,99,235,0.2),transparent)' }} />
              </div>
            ))}
          </div>
        </div>

        {/* ── Right: Feature Cards ── */}
        <div style={{ display:'grid', gridTemplateColumns: isMobile?'1fr 1fr':isTablet?'1fr 1fr 1fr':'1fr 1fr', gap:14 }}>
          {FEATURES.map(({ icon: Icon, color, title, desc }) => (
            <div key={title} style={{ borderRadius:18, padding: isMobile?16:20, background:'rgba(255,255,255,0.04)', backdropFilter:'blur(14px)', border:'1px solid rgba(255,255,255,0.07)', transition:'all 0.3s' }}
              onMouseEnter={e => { e.currentTarget.style.transform='translateY(-4px)'; }}
              onMouseLeave={e => { e.currentTarget.style.transform='none'; }}>

              <div style={{ width: isMobile?36:42, height: isMobile?36:42, borderRadius:11, display:'flex', alignItems:'center', justifyContent:'center', background:`${color}18`, border:`1px solid ${color}30`, marginBottom:12 }}>
                <Icon size={isMobile?18:21} color={color} strokeWidth={1.8} />
              </div>

              <div style={{ fontFamily:"'Outfit',sans-serif", fontSize: isMobile?13:14, fontWeight:700, color:'#fff', marginBottom:6 }}>{title}</div>
              <div style={{ fontFamily:"'DM Sans',sans-serif", fontSize: isMobile?11:12, color:'#475569', lineHeight:1.65 }}>{desc}</div>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
}